export default __webpack_public_path__ + "static/media/cardThumb.97e2efc8.svg";